import type { FilterSearchParams } from "../../types/filter";

export const normalizeFilterSearchParams = (
  params: FilterSearchParams
): FilterSearchParams => ({
  ...params,
  radius: params.geoLocation ? params.radius : undefined,
});
